export default "__VITE_ASSET__DyNXKw$C__"